package com.cybersoftsolution.cybersoftsolutionweb.components.buttons

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.text.MySpanText
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.ForgetPasswordButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyleDisabled
import com.cybersoftsolution.cybersoftsolutionweb.styles.SecondaryButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SecondaryButtonStyleDisabled
import com.cybersoftsolution.cybersoftsolutionweb.utils.Utils.darker
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.disabled
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.backgroundColor

import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button

@Composable
    fun MyButton(
    borderRadius: CSSSizeValue<CSSUnit.px> = 15.px,
    isActive: Boolean = false,
    width: CSSSizeValue<CSSUnit.px>? = null,
    buttonType: MyButtonType = MyButtonType.Primary,
    modifier: Modifier = Modifier,
    id: String,
    text: String?=null,
    fontSize:Int = 16,
    enabled: Boolean = true,
    onClick: () -> Unit = {}
    ){




        val style = when (buttonType){
            MyButtonType.Primary -> {
                if (enabled) PrimaryButtonStyle else PrimaryButtonStyleDisabled
            }
            MyButtonType.Secondary -> {
                if (enabled) SecondaryButtonStyle else SecondaryButtonStyleDisabled
            }
            MyButtonType.Delete -> {
                if (enabled) PrimaryButtonStyle else PrimaryButtonStyleDisabled
            }
            MyButtonType.Edit -> {
                if (enabled) PrimaryButtonStyle else PrimaryButtonStyleDisabled
            }
        }


    val activeButtonStyle =  style.toModifier()
        .boxShadow(
            offsetX = 0.px,
            offsetY = 0.px,
            blurRadius = 5.px,
            spreadRadius = 1.px,
            color = Theme.HalfBlack.rgb
        )
        .styleModifier {
            backgroundColor(buttonType.enabledBackgroundColor.darker())
        }

            Button(
                attrs = style.toModifier()
                    .height(100.percent)
                    .thenIf(
                        condition = width != null,
                        other = Modifier.width(width ?: 100.percent)
                    )
                    .borderRadius(borderRadius)
                    .then(modifier)
                    .id(id)
                    .disabled(!enabled)
                    .backgroundColor(if (enabled) buttonType.enabledBackgroundColor else buttonType.disableBackgroundColor)
                    .thenIf(
                        condition = isActive,
                        other = Modifier.then(activeButtonStyle)
                    )

                    .thenIf(
                        condition = enabled,
                        other = Modifier.cursor(Cursor.Pointer)
                    )
                    .onClick { onClick() }
                    .flexShrink(1) // Allow the button to shrink within the Row
                    .overflow(Overflow.Hidden) // Hide any potential overflow from the button itself

                    .toAttrs(),
            ){
                text?.let {
    //                Text(text)
                    MySpanText(
                        fontSize = fontSize,
//                        maxLines = 1,
                        text = text,
                        fontColor = buttonType.textFontColor,
                    )
//                    SpanText(
//                        text = text,
//                        modifier = Modifier
//                            .fontSize(fontSize.px)
//                            .color(buttonType.textFontColor)
//                            .whiteSpace(WhiteSpace.NoWrap) // Prevent text wrapping
//                            .overflow(Overflow.Hidden) // Hide overflowing text
//                            .textOverflow(TextOverflow.Ellipsis) // Add ellipsis for overflow
//                    )

                }

            }
    }





sealed class MyButtonType(type : String, val enabledBackgroundColor: CSSColorValue, val disableBackgroundColor :CSSColorValue, val textFontColor: CSSColorValue){
    data object Primary: MyButtonType(
        type = "Primary",
        enabledBackgroundColor = Theme.PrimaryButton.rgb,
        disableBackgroundColor = Colors.LightGray,
        textFontColor = Colors.Black
    )
    data object Secondary: MyButtonType(
        type = "Secondary",
        enabledBackgroundColor = Colors.Transparent,
        disableBackgroundColor = Colors.LightGray,
        textFontColor = Colors.Black,
    )
    data object Delete: MyButtonType(
        type = "Delete",
        enabledBackgroundColor = Colors.DarkRed,
        disableBackgroundColor = Colors.LightGray,
        textFontColor = Colors.White,
    )
    data object Edit: MyButtonType(
        type = "Edit",
        enabledBackgroundColor = Colors.Green,
        disableBackgroundColor = Colors.LightGray,
        textFontColor = Colors.White,
    )

}